const VERSION = "6.1.2";
export {
  VERSION
};
